import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import { Resolve } from 'vue-di';
import { Settings } from '~/services/settings';

export interface IEligibilityData {
    eligibilityFederal?: string;
    diagnosis?: string;
    doesAgreeMarketing?: string;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    public eligibilityData: SurveySessionValueModel[] = [];

    public isEligible = false;

    public isMarketingOptInCheck = false;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData | any) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Action({ rawError: true })
    public checkPatientEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        const correctAnswers = [
            +this.settings.hasBeenPrescribedAnswerYes,
            +this.settings.isCommerciallyInsuredAnswerYes,
            +this.settings.isFederalAnswerYes,
            +this.settings.isUSResidentAnswerYes,
            +this.settings.iConsentAnswerYes,
        ] as number[];

        const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;

    }

    @Mutation
    public async updateIsMarketingOptInCheck(isMarketingOptInCheck: boolean) {
        this.isMarketingOptInCheck = isMarketingOptInCheck;
    }
}
